module.exports = __webpack_public_path__ + "img/idCard2.f72e9648.png";